/* jshint ignore:start */
var FormsManager = (function($) {
    var instance;



    function init()
    {


        function resetForm($form) {
            $form.find('.js-form-ele').removeClass('form__control--ok').removeClass('form__control--ko');
            $form.find('.js-btn-form').attr('disabled', false);

            var code = $form.data('code');

            switch (code) {
                case 'contacto':
                    $('#name').val('');
                    $('#company').val('');
                    $('#email').val('');
                    $('#phone').val('');
                    $('#comment').val('');
                    break;

                case 'newsletter':
                    $('#email').val('');
                    $('#name').val('');
                    $('#surname').val('');
                    break;

                case 'boletin':
                    $('#name').val('');
                    $('#email').val('');
                    $('#comment').val('');
                    break;

                case 'denuncias':       
                    $('#name').val('');      
                    $('#email').val('');       
                    $('#phone').val('');
                    $('#direccion').val('');
                    $('#comment').val('');
                    break;

                default:
                    break;
            }
        }

        function checkRedirection($form,code)
        {
            switch (code) {
                case 'contacto':
                case 'course':
                    // $('.js-preloader-layer').append('<div class="form__layer-preloader"></div>');

                    var redirection = $form.data('redirection');
                    window.location = redirection;


                    return true;

                default: return false;
            }
        }

        function manageExtraActions($form,code)
        {
            var env = $form.data('env');

            switch (code) {
                default: break;
            }
        }

        function getFormRules(codeForm)
        {
            switch (codeForm) {
                case 'contacto':
                    return {
                        'name': { required: true },
                        // 'company': { required: true },
                        'email': { required: true, email: true },
                        // 'phone': { required: true, digits: true },
                        'comment': { required: true },
                        'accept': { required: true }
                    };

                case 'newsletter':
                    return {
                        'email': { required: true, email: true },
                        'name': { required: true},
                        'surname': { required: true },
                        'newsletter-categories[]': { required: true, minlength: 1 },
                        'accept': { required: true }
                    };

                case 'single':
                    return {
                        'name': { required: true },
                        'email': { required: true, email: true },
                        'comment': { required: true }
                    };

                case 'course':
                    return {
                        'course_title': { required: true },
                        'course_company': { required: true },
                        'course_dates': { required: true },
                        'course_place': { required: true },
                        'course_web': { required: false, url: true },
                        'course_detail': { required: true },

                        'name': { required: true },
                        'email': { required: true, email: true },
                        // 'phone': { required: true, digits: true },
                        // 'comment': { required: true },
                        'accept': { required: true }
                    };

                case 'comment':
                    return {
                        'author': { required: true },
                        'email': { required: true, email: true },
                        'comment': { required: true }
                    };

                case 'login':
                    return {
                        'username': { required: true },
                        'password': { required: true}
                    };

                case 'denuncias':
                    return {
                        'empresa_denuncia':{ required: true },
                        'comment': { required: true },
                        'accept': { required: true }
                    };

                default:
                    return {
                        'name': { required: true },
                        'email': { required: true, email: true },
                        'comment': { required: true }
                    };
            }

        }

        function afterModaalOpen() {
            $('.modaal-wrapper').addClass('modaal-ov-scroll');
        }


        return {
            init: function()
            {
                this.initForms();

                var $privacyCheck = $('.js-privacy-check');
                if ($privacyCheck.length) {

                    $privacyCheck.modaal({
                        after_open: afterModaalOpen
                    });
                }

                //this.initFormLogin();
            },

            initForms: function()
            {
                var ref = this;

                var $forms = $('.js-form');
                if ($forms.length) {

                    $forms.each(function () {
                        ref.initForm($(this));
                    });
                }
            },

            initForm: function($form) {

                var ref = this;

                var code;
                if ($form.hasClass('js-form-comment')) {
                    code ='comment';
                } else {
                    code = $form.data('code');
                }



                $form.validate({
                    event: "blur",
                    rules: getFormRules(code),
                    validClass: "form__control--ok",
                    errorClass: "form__control--ko",
                    highlight: function(element, errorClass, validClass){
                        var $element = $(element);
                        if ($element.hasClass('js-check')) {
                            var $parent = $(element).closest(".form__checkbox");
                            $parent.addClass('form__checkbox--ko').removeClass('form__checkbox--ok');
                        } else {
                            $element.addClass(errorClass).removeClass(validClass);
                        }

                    },
                    unhighlight: function(element, errorClass, validClass){
                        var $element = $(element);
                        if ($element.hasClass('js-check')) {
                            var $parent = $(element).closest(".form__checkbox");
                            $parent.removeClass('form__checkbox--ko').addClass('form__checkbox--ok');
                        } else {
                            $element.removeClass(errorClass).addClass(validClass);
                        }

                    },
                    errorPlacement: function(error, element) {
                        var $message = $form.find('.js-form-message');
                        $message.removeClass('form__control--ko').removeClass('form__control--ok');
                        $message.addClass('form__validation--ko');
                        $message.html('<p class="form__validation-text">Revisa los campos obligatorios.</p>');
                    },
                    submitHandler: function(form) {
                        var $myform = $(form);


                        $myform.find('.js-btn-form').attr('disabled', true);

                        var $message = $form.find('.js-form-message');
                        $message.removeClass('form__validation--ko').removeClass('form__validation--ok');
                        $message.addClass('form__validation--ok');
                        $message.html('<p class="form__validation-text">Enviando...</p>');

                        if (code === 'comment' || code == 'denuncias') {
                            form.submit();
                        } else if (code === 'login') {
                            ref.sendLogin();
                        }
                        else {
                            ref.sendForm($myform);
                        }
                    }
                });

                $form.find('.js-btn-form').on('click', function(e) {
                    e.preventDefault();

                    //$form.submit();
                    $(this).closest('form').submit();
                });

                /*$form.find('.js-btn-form-comment').on('click', function(e) {
                    e.preventDefault();
                    var $formEle = $(this).closest('form');
                    console.log('enviar comentario');

                    console.log($form);

                    //$form.submit();
                    $formEle.submit();
                });*/
            },

            sendForm: function($form)
            {
                var ref = this;

                $.ajax({
                    type: "POST",
                    dataType: 'json',
                    url: $form.data('url'),
                    contentType: "application/x-www-form-urlencoded",
                    processData: false,
                    data: $form.serialize(),
                    success: function(response){
                        // console.log(response);
                        ref.onResultForm(response, $form);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        var data = JSON.parse(jqXHR.responseText);
                        ref.onErrorForm(data, $form);
                    }
                });
            },

            onResultForm: function(data, $form)
            {
                var $message = $form.find('.js-form-message');
                $message.removeClass('form__validation--ko').removeClass('form__validation--ok');

                if (!data.ERROR && data.status === 'OK') {

                    var code = $form.data('code');

                    if (!checkRedirection($form,code)) {
                        $message.addClass('form__validation--ok');
                        $message.html('<p class="form__validation-text">'+ data.message + '</p>');

                        manageExtraActions($form,code);
                    }


                } else {
                    $message.addClass('form__validation--ko');
                    $message.html('<p class="form__validation-text">'+ data.message +'</p>');
                }

                TweenMax.to($message, 0.6, { opacity:0, ease:Power2.easeInOut, delay:5, onComplete:function(){
                    $message.removeClass('form__validation--ko').removeClass('form__validation--ko');
                    $message.html('');

                    resetForm($form);

                    TweenMax.to($message, 0.2, { opacity:1 });
                }});
            },

            onErrorForm: function(data, $form)
            {
                var $message = $form.find('js-form-message');
                $message.removeClass('form__validation--ko').removeClass('form__validation--ok');

                $message.addClass('form__validation--ko');
                $message.html('<p class="form__validation-text">Ha ocurrido un error</p>');
            },

            sendLogin: function() {

                var $form = $('.js-login-form');
                $form.find('#login-error_message').hide();
                $form.find('#login-success_message').show();

                var username = $('#username').val();
                var password = $('#password').val();
                if (username && password) {
                    jQuery.ajax({
                        type: 'POST',
                        dataType: 'json',
                        url: $form.data('url'),
                        data: {
                            'action': 'ajaxlogin', //calls wp_ajax_nopriv_ajaxlogin
                            'username': username,
                            'password': password,
                            'security': $('form#login #security').val() },
                        success: function(data){
                            if (data.loggedin == true){
                                location.reload();
                            } else {
                                $form.find('#c-error_message').show();
                                $form.find('#login-success_message').hide();
                            }
                        }
                    });
                }
            }
        };
    }


    return {

        getInstance: function(){

            if (!instance){
                instance = init();
            }

            return instance;
        }

    };


})(jQuery);
/* jshint ignore:end */